// NotificationTabContent/InvoiceNotification.js
import React from "react";

const invoiceData = [
  {
    id: 1,
    title: "Invoice Approved",
    message: "Invoice #INV1040 approved by finance",
    timestamp: "3h ago"
  },
  {
    id: 2,
    title: "New Draft Invoice",
    message: "Draft invoice #INV1180 ready for review",
    timestamp: "6h ago"
  },
  {
    id: 3,
    title: "Invoice Rejected",
    message: "Invoice #INV1133 rejected due to mismatch",
    timestamp: "1d ago"
  }
];

const InvoiceNotification = () => {
  return (
    <div className="flex flex-col gap-fluid-1.5 max-h-[24rem] overflow-y-auto px-fluid-2 py-fluid-2 scrollbar-thin">
      {invoiceData.map((item) => (
        <div key={item.id} className="p-fluid-1.5 bg-white hover:bg-gray-50 rounded-lg border">
          <p className="text-fluid-base font-semibold text-gray-800">{item.title}</p>
          <p className="text-fluid-sm text-gray-600">{item.message}</p>
          <p className="text-fluid-xs text-gray-400 mt-0.5">{item.timestamp}</p>
        </div>
      ))}
    </div>
  );
};

export default InvoiceNotification;
